import {observer} from 'mobx-react-lite';
import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {EHeaderButton} from 'webapp-lib/Components';

import {NotificationSummary} from '@lexian/api/notifications-api';
import {Notification as NotificationIcon} from '_/assets/images';
import {Loadable} from '_/utilities/types';

const UNotificationsButton = ({
  onClick,
  summary,
  isActive,
}: {
  summary: Loadable<NotificationSummary>;
  onClick: () => void;
  isActive: boolean;
}): React.ReactElement => {
  const {t} = useTranslation('common');
  const {hasInformativeFlag, contentData, importantFlag} = useMemo(() => {
    const {data} = summary;

    if (!data) {
      return {
        hasInformativeFlag: false,
        contentData: undefined,
        importantFlag: false,
      };
    }

    const hasInformativeNotification =
      data.unreadInformativeNotifications > 0 &&
      data.unreadResolvableNotifications === 0;
    const contentItem =
      data.unreadResolvableNotifications > 99
        ? '99+'
        : data.unreadResolvableNotifications;

    return {
      hasInformativeFlag: hasInformativeNotification,
      contentData: contentItem,
      importantFlag: data.hasImportantNotification,
    };
  }, [summary]);

  return (
    <EHeaderButton
      attentionFlag={hasInformativeFlag}
      contentFlag={
        contentData
          ? {
              content: contentData,
              mode: 'informative',
            }
          : undefined
      }
      isActive={isActive}
      title={t('headerButtons.notifications')}
      warningFlag={importantFlag}
      onClick={onClick}
    >
      <NotificationIcon />
    </EHeaderButton>
  );
};
export const NotificationsButton = observer(UNotificationsButton);
